import { render, staticRenderFns } from "./PerformanceGraph.vue?vue&type=template&id=b1b0ee42"
import script from "./PerformanceGraph.vue?vue&type=script&lang=js"
export * from "./PerformanceGraph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports